import React from "react";
import { Row, Col, Input, Select, Icon } from "antd";
import { useSelector } from "react-redux";
import useStockMovementContext from "../../../../hooks/useStockMovementContext";
import ButtonStandard from "../../../../components/utils/button";
import StockMovementSummaryCards from "./StockMovementSummaryCards";
import StockMovementTable from "./StockMovementTable";
import StockMovementFormModal from "./StockMovementFormModal";
import StockMovementDetailDrawer from "./StockMovementDetailDrawer";
import StockMovementDuplicateNfModal from "./StockMovementDuplicateNfModal";
import DrawerManufacturer from "../../../../components/drawers/manufacturer";
import UnitForm from "../../../unit/form";

const { Search } = Input;
const { Option } = Select;

const StockMovementsTab = () => {
  const { translation } = useSelector((state) => state.app);
  const tm = translation?.stockItem?.movements || {};
  const tFilter = tm.filter || {};
  const tButtons = tm.buttons || {};

  const {
    searchTerm,
    filterType,
    duplicateNfAlert,
    handleSearch,
    handleFilterChange,
    handleOpenNewMovement,
    closeDuplicateNfAlert,
    handleRefresh,
  } = useStockMovementContext();

  return (
    <>
      <Row
        gutter={16}
        style={{ marginBottom: 16 }}
        type="flex"
        align="middle"
        justify="space-between"
      >
        <Col>
          <Row type="flex" align="middle" gutter={8}>
            <Col>
              <Search
                value={searchTerm}
                placeholder={
                  tm.searchPlaceholder || "Buscar por item, ID ou NF..."
                }
                onChange={(e) => handleSearch(e.target.value)}
                onSearch={handleSearch}
                style={{ width: 300 }}
                allowClear
              />
            </Col>
            <Col>
              <Select
                value={filterType}
                onChange={handleFilterChange}
                style={{ width: 150 }}
              >
                <Option value="ALL">{tFilter.all || "Todos"}</Option>
                <Option value="ENTRY">{tFilter.entries || "Entradas"}</Option>
                <Option value="EXIT">{tFilter.exits || "Saídas"}</Option>
                <Option value="INACTIVE">
                  {tFilter.inactive || "Inativados"}
                </Option>
              </Select>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row type="flex" align="middle" gutter={8}>
            <Col>
              <ButtonStandard
                buttonType="typeWithoutBackground"
                onClick={handleRefresh}
              >
                <Icon type="reload" />
              </ButtonStandard>
            </Col>
            <Col>
              <ButtonStandard
                type="button"
                buttonType="addNew"
                onClick={() => handleOpenNewMovement("ENTRY")}
              >
                <Icon type="download" /> {tButtons.newEntry || "Entrada"}
              </ButtonStandard>
            </Col>
            <Col>
              <ButtonStandard
                type="button"
                buttonType="typeWithoutBackgroundWithBorder"
                onClick={() => handleOpenNewMovement("EXIT")}
              >
                <Icon type="upload" /> {tButtons.newExit || "Saída"}
              </ButtonStandard>
            </Col>
          </Row>
        </Col>
      </Row>

      <StockMovementSummaryCards />
      <StockMovementTable />
      <StockMovementFormModal />
      <DrawerManufacturer />
      <UnitForm />
      <StockMovementDetailDrawer />
      <StockMovementDuplicateNfModal
        visible={duplicateNfAlert.show}
        message={duplicateNfAlert.message}
        missingItems={duplicateNfAlert.missingItems}
        onCancel={closeDuplicateNfAlert}
        onContinue={closeDuplicateNfAlert}
      />
    </>
  );
};

export default StockMovementsTab;
